<template>
	<main class="app-main">
		<div class="content-wrap">
			<section class="content-section" v-if="investmentsSympatiaAccount">
				<header class="section-header">
					<h2 class="section-title">{{ $t('routes.investments_sympatia_account.title') }}:
						<span v-if="investmentsSympatiaAccount.name">{{ investmentsSympatiaAccount.name }} -</span>
						{{ investmentsSympatiaAccount.account_id }}
					</h2>
					<p v-if="investmentsSympatiaAccount.values_valid_at">{{ $t('investments.values_valid', { date: investmentsSympatiaAccount.values_valid_at }) }}</p>
				</header>
				<article>
					<actions-panel>
						<a class="button style-1" @click.prevent="$router.safeBack">
							<span class="inner">{{ $t('general.back') }}</span>
						</a>
					</actions-panel>
					<chart-panels-group :panels-data="panelsData" :charts-data="chartsData" v-if="panelsData.length" :tabs="true"/>
					<p v-else>{{ $t('investments.no_data') }}</p>
				</article>
			</section>
		</div>
	</main>
</template>

<script>
import investmentsMixin from "@/mixins/investmentsMixin";
import ActionsPanel from "@/components/panels/ActionsPanel";
import ChartPanelsGroup from "@/components/containers/ChartPanelsGroup";
import PanelBoxesContainer from "@/components/containers/PanelBoxesContainer";

export default {
	name: "InvestmentsSympatiaAccount",
	components: {
		ActionsPanel,
		ChartPanelsGroup,
		PanelBoxesContainer
	},
	mixins: [investmentsMixin],
	computed: {
		investmentsSympatiaAccount() {
			return this.$store.state.views.investmentsSympatiaAccount;
		},
		chartsData() {
			return [
				this.balanceChart,
				this.portfoliosChart,
			];
		},
		balanceChart() {
			let data = this.getBalanceChartOptions();
			data.tabName = this.$t('investments.profit');

			let series = [
				{
					name: this.$t('investments.account_balance'),
					data: [],
				},
				{
					name: this.$t('investments.transactions'),
					data: [],
				}
			];

			this.investmentsSympatiaAccount.history.forEach(item => {
				series[0].data.push({
					x: item.date,
					y: item.amount,
				});
			});

			let balance = 0;
			let transactions = this.investmentsSympatiaAccount.transactions.slice().sort((a, b) => {
				return new Date(a.date) - new Date(b.date);
			});
			transactions.forEach(item => {
				let amount = parseFloat(item.amount);
				if (item.type === 'withdrawal') {
					amount = amount * -1;
				}
				balance += amount;
				series[1].data.push({
					x: item.date,
					y: balance.toFixed(2),
				});
			});

			let currentDate = new Date().toISOString().slice(0, 10);
			series[0].data.push({
				x: currentDate,
				y: this.investmentsSympatiaAccount.balance,
			});
			series[1].data.push({
				x: currentDate,
				y: balance.toFixed(2),
			});

			data.series = series;
			data.totalBalance = this.investmentsSympatiaAccount.balance;
			data.totalDeposits = this.investmentsSympatiaAccount.deposit;
			data.totalWithdrawals = this.investmentsSympatiaAccount.withdrawal;
			data.totalFees = this.investmentsSympatiaAccount.fee;
			data.totalReturn = this.investmentsSympatiaAccount.return;

			return data;
		},
		portfoliosChart() {
			let data = this.getPortfoliosChartOptions();
			data.tabName = this.$t('investments.allocation');

			let series = [];
			let labels = [];
			this.investmentsSympatiaAccount.fonds.forEach(item => {
				series.push(parseFloat(item.total_value));
				labels.push(item.fund_name);
			});

			data.chartOptions.labels = labels;
			data.series = series;

			return data;
		},
		panelsData() {
			let data = [];
			this.investmentsSympatiaAccount.fonds.forEach(item => {
				data.push({
					id: item.id,
					category: this.$t('investments.fund'),
					name: item.fund_name,
					description: this.$t('investments.fund_balance'),
					price: parseFloat(item.native_value ?? item.total_value).toFixed(2),
					returnPercentage: item.return_percentage,
					type: 'portfolio',
					portfolioType: 'sympatia',
					isin: item.isin,
					currency: this.getCurrencySymbol(item.currency),
					detail: !!item.isin,
				});
			});

			return data;
		},
	}
}
</script>

<style scoped>

</style>
